import { Uuid } from "@/domains/global/identifiers";
import { MDSRowItemAppearance } from "@/mds";
import { AppStore } from "@/store";

export const resolveItemAppearance = ({
  itemId,
  appStore,
}: {
  itemId: Uuid;
  appStore: AppStore;
}): MDSRowItemAppearance => {
  const noteObservable = appStore.notes.get(itemId);

  if (noteObservable?.suggestionData) {
    return MDSRowItemAppearance.ActiveSuggestion;
  }

  const audioRecordingObservable = appStore.audioRecordings.getNoteRecording({
    noteId: itemId,
  }).recording;

  if (audioRecordingObservable?.associatedNoteId === itemId) {
    if (audioRecordingObservable.hasFailedUploading) {
      return MDSRowItemAppearance.AudioRecordingUploadingFailed;
    }

    if (audioRecordingObservable.hasFailedProcessing) {
      return MDSRowItemAppearance.AudioRecordingProcessingFailed;
    }

    if (audioRecordingObservable.isUploading) {
      return MDSRowItemAppearance.AudioRecordingUploading;
    }

    if (audioRecordingObservable.isProcessing) {
      return MDSRowItemAppearance.AudioRecordingProcessing;
    }

    if (audioRecordingObservable.isRecording) {
      return MDSRowItemAppearance.AudioRecordingRecording;
    }
  }

  return MDSRowItemAppearance.Standard;
};
